import { render, staticRenderFns } from "./AmericanArchitectureAwardFrame.vue?vue&type=template&id=d822ecf2"
import script from "./AmericanArchitectureAwardFrame.vue?vue&type=script&lang=js"
export * from "./AmericanArchitectureAwardFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d822ecf2')) {
      api.createRecord('d822ecf2', component.options)
    } else {
      api.reload('d822ecf2', component.options)
    }
    module.hot.accept("./AmericanArchitectureAwardFrame.vue?vue&type=template&id=d822ecf2", function () {
      api.rerender('d822ecf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/american-architecture-award/components/AmericanArchitectureAwardFrame.vue"
export default component.exports